import {DefaultSettings, settings} from '../../../settings/settings-util';
import reducer from './reducers';
import watch from 'redux-watch';
import * as Actions from './actions/actions';
import {AlmeState} from "../../../wireup/AlmeState";
import {Reducer, Store} from "redux";
import {Message} from "../../../types/response";
import {AlmeResponseV5} from "@alme/types/response/AlmeResponse";
import {HistoryMessageError} from "../../../types/history";


export default class HistoryAppender
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;


    //#region Public Interface

    constructor(passedSettings: DefaultSettings = settings)
    {
        this._settings = passedSettings;
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    getReducer(): Reducer<AlmeState["History"]>
    {
        return reducer;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;

        const { Base, processedResponse } = this._settings.stateLocations.Conversation;

        const sentInputWatcher = watch(this._store.getState.bind(this), `${Base}.${processedResponse}`);
        const processedResponseWatcher = watch(this._store.getState.bind(this), `${Base}.${processedResponse}`);
        const processedErrorWatcher = watch(this._store.getState.bind(this), `${Base}.${processedResponse}`);

        this._store.subscribe(sentInputWatcher((newVal: Message) => this.appendSentInputToHistory(newVal)));
        this._store.subscribe(processedResponseWatcher((newVal: Message) => this.appendProcessedResponseToHistory(newVal)));
        this._store.subscribe(processedErrorWatcher((newVal: Message) => this.appendErrorToHistory(newVal)));
    }

    //#endregion



    //#region History Methods

    appendSentInputToHistory(message?: Message): void
    {
        const { converseRequest, requestUnitRequest, userInputType } = this._settings.messageConstants;

        if (message?.error ||
           (message?.messageType !== converseRequest && message?.messageType !== requestUnitRequest) ||
            (message?.response as AlmeResponseV5).extensionData.MessageSource === this._settings.livechat.messageSource ||
           ((message?.response as AlmeResponseV5).maskedInput?.trim() ?? 0) <= 0)
        {
            return;
        }

        const { responseRevision, maskedInput, extensionData } = message?.response as AlmeResponseV5;

        const historyMessage = {
            type: userInputType,
            responseRevision,
            maskedInput,
            extensionData,
        };

        this._store?.dispatch(Actions.appendSentInput(historyMessage, this._settings.stateLocations.History.Messages));
    }

    appendErrorToHistory(message?: Message): void
    {
        if (!message?.error)
        {
            return;
        }

        const historyMessage = {
            type: this._settings.messageConstants.errorResponseType,
            responseRevision: 0,
            text: "",
            navUrl: null,
            displayLinkCollection: null,
            responseActions: null,
            extensionData: (message.response as AlmeResponseV5).extensionData,
            statusCode: message?.statusCode,
            errorText: message?.errorText,
        } as HistoryMessageError;

        this._store?.dispatch(Actions.appendError(historyMessage, this._settings.stateLocations.History.Messages));
    }

    appendProcessedResponseToHistory(message?: Message): void
    {
        if (!this.doesPersistToHistory(message) || !(message?.response as AlmeResponseV5).text)
        {
            return;
        }

        const { responseRevision, text, navUrl, displayLinkCollection, responseActions, extensionData } = message?.response as AlmeResponseV5;

        const historyMessage = {
            type: this._settings.messageConstants.almeResponseType,
            responseRevision,
            text,
            navUrl,
            displayLinkCollection,
            responseActions,
            extensionData,
        };

        const timeout = this._settings.History.appendDelay ?? 0;

        setTimeout(
            () => {
                this._store?.dispatch(Actions.appendReceivedResponse(historyMessage, this._settings.stateLocations.History.Messages))
            },
            timeout
        );
    }



    //#endregion



    //#region Helper Methods

    doesPersistToHistory(message?: Message): boolean
    {
        const { converseRequest, requestUnitRequest, appeventRequest} = this._settings.messageConstants;

        return message?.messageType === converseRequest ||
            message?.messageType === requestUnitRequest ||
            message?.messageType === appeventRequest;
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/history-appender-maskedinput/src/history-appender-maskedinput.ts